var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 306,
    viewBox: "0 0 86 306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(-5480 -1487)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-2",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-2",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-2",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-2",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-2",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-2",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-3",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-3",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-3",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-3",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-3",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-2",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-4",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-4",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-4",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-4",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-4",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(0 80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-2",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-3",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-5",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-5",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-5",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-5",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-5",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-3",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-6",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-6",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-6",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-6",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-6",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-2",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-4",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-7",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-7",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-7",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-7",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-7",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-4",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-8",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-8",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-8",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-8",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-8",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(0 160)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159-2",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-3",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-5",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-9",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-9",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-9",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-9",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-9",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-5",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-10",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-10",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-10",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-10",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-10",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-3",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-6",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-11",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-11",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-11",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-11",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-11",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-6",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-12",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-12",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-12",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-12",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-12",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160-2",
    "data-name": "Group 160",
    transform: "translate(0 80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-4",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-7",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-13",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-13",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-13",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-13",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-13",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-7",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-14",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-14",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-14",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-14",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-14",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-4",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-8",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-15",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-15",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-15",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-15",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-15",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-8",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-16",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-16",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-16",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-16",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-16",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.7badcde2b9806dab7741cfebd656494e.svg";
export { ForwardRef as ReactComponent };